import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, type OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorCodes } from '@core/enums/errors.enum';
import { PrimeNgSettings } from '@core/static/primeng.static';

import { Invite } from '@features/organizations/models/invite.model';
import { OrganizationsService } from '@features/organizations/services/organizations.service';
import { Store } from '@ngxs/store';
import { SetUserOrganizations } from '@stores/organizations/organizations.actions';

import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';
import { catchError, EMPTY, switchMap } from 'rxjs';

@Component({
  selector: 'tr-invite',
  imports: [CommonModule, MessageModule, ButtonModule],
  templateUrl: './Invite.component.html',
  styleUrl: './Invite.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InviteComponent implements OnInit {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private orgService = inject(OrganizationsService);
  private messageService = inject(MessageService);
  private store = inject(Store);

  invite: Invite | null = null;
  accepting: boolean = false;

  constructor() {
    this.route.data.subscribe(({ invite }) => {
      this.invite = invite;
    });
  }

  ngOnInit(): void {}

  acceptInvite() {
    this.accepting = true;
    this.orgService
      .acceptInvite(this.invite!.code)
      .pipe(
        catchError((err) => {
          if (err.code === ErrorCodes.InviteAssociatedAlready) {
            sessionStorage.removeItem('inviteCode');

            this.messageService.add({
              severity: 'warn',
              key: 'main-toast',
              summary: 'Failed',
              detail: 'Looks like you are already associated with this organization.',
              life: PrimeNgSettings.MessageLife,
            });

            this.router.navigate(['/']);
          } else if (err.code === ErrorCodes.AdminMax) {
            sessionStorage.removeItem('inviteCode');

            this.messageService.add({
              severity: 'warn',
              key: 'main-toast',
              summary: 'Failed',
              detail: 'Sorry, you have reached the maximum number of organizations that you can manage.',
              life: PrimeNgSettings.MessageLife,
            });

            this.router.navigate(['/']);
          }
          return EMPTY;
        }),

        switchMap((organizations) => {
          sessionStorage.removeItem('inviteCode');
          return this.store.dispatch(new SetUserOrganizations(organizations, this.invite?.organization.id));
        })
      )
      .subscribe({
        next: () => {
          sessionStorage.removeItem('inviteCode');

          this.messageService.add({
            severity: 'success',
            key: 'main-toast',
            summary: 'Accepted Invite',
            detail: 'Successfully accepted invite, the organization has been automatically selected for you.',
            life: PrimeNgSettings.MessageLife,
          });

          this.router.navigate(['/members']);
        },
        error: (err) => {
          this.messageService.add({
            severity: 'warn',
            key: 'main-toast',
            summary: 'Failed',
            detail: 'Looks like you are already associated with this organization.',
            life: PrimeNgSettings.MessageLife,
          });
        },
      });
  }
}
